import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  Grid,
  Box,
  IconButton,
  Typography,
  Slide,
  useTheme,
  styled,
  Stack,
  useMediaQuery,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Snackbar,
  Alert,
  Checkbox,
  FormControlLabel,
  Link,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import callBackFormSubmit from "../services/callBackFormSu";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "20px",
    padding: "20px",
    maxWidth: "500px",
    width: "90%",
    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
    [theme.breakpoints.down("sm")]: {
      margin: "10px",
      width: "calc(100% - 20px)",
      maxWidth: "none",
      padding: "15px",
      borderRadius: "15px",
    },
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "white",
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#00cc87",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#00cc87",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#666",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#00cc87",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: "12px",
  padding: "5px 30px",
  fontSize: "16px",
  marginTop: "20px",
  fontWeight: "bold",
  textTransform: "none",
  background: "#00cc87",
  boxShadow: "0 8px 20px rgba(211, 47, 47, 0.3)",
  "&:hover": {
    background: "#0c9ffa",
    boxShadow: "0 12px 25px rgba(211, 47, 47, 0.4)",
    transform: "translateY(-2px)",
  },
  transition: "all 0.3s ease",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "8px 20px",
    fontSize: "14px",
    marginTop: "15px",
  },
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: 8,
  top: 8,
  color: "#666",
  "&:hover": {
    backgroundColor: "rgba(211, 47, 47, 0.1)",
    color: "#00cc87",
  },
  [theme.breakpoints.down("sm")]: {
    right: 5,
    top: 5,
    padding: "4px",
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
    },
  },
}));

export default function LoanPopupForm({ timeout, popUpId }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    loanType: "",
    state: "",
    pincode: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Show popup after 5 seconds
  useEffect(() => {
    const timeoutDuration = timeout === "more" ? 5000 : 15000;

    const timer = setTimeout(() => {
      setOpen(true);
    }, timeoutDuration);

    return () => clearTimeout(timer);
  }, [timeout]); // Add timeout as a dependency

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const loanTypes = [
    "Select Loan Type",
    "Used Commercial Vehicle Loan",
    "Used Car Loan",
    "Used Truck Loan",
    "EV Car Loan",
    "EV Truck Loan",
    "EV 3 Wheeler Loan",
    "Business Loan",
  ];

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      // First API call (your existing one)
      await callBackFormSubmit(formData);

      // Second API call for email (new)
      const emailFormData = new FormData();

      // Map your form fields to the email API format
      emailFormData.append("smtpEmail", "psnfinanceblr@gmail.com");
      emailFormData.append("appPassword", "pnyl ysdr vfxk avmj");
      emailFormData.append("toEmail", "psnfinanceblr@gmail.com");
      emailFormData.append(
        "subject",
        `New Loan Application - ${formData["loan-type"]}`
      );

      // Create message content
      const message = `New loan application received.\n\nName: ${formData.name}\nEmail: ${formData["email-address"]}\nPhone: ${formData["phone-number"]}\nLoan Type: ${formData["loan-type"]}\nState: ${formData.state}\nPin Code: ${formData["pin-code"]}`;

      const html = `
       <h3>New Loan Application</h3>
       <p><strong>Name:</strong> ${formData.name}</p>
       <p><strong>Email:</strong> ${formData["email-address"]}</p>
       <p><strong>Phone:</strong> ${formData["phone-number"]}</p>
       <p><strong>Loan Type:</strong> ${formData["loan-type"]}</p>
       <p><strong>State:</strong> ${formData.state}</p>
       <p><strong>Pin Code:</strong> ${formData["pin-code"]}</p>
     `;

      emailFormData.append("message", message);
      emailFormData.append("html", html);

      // Send email
      const emailResponse = await fetch(
        "https://email-sender.backendprod.com/api/send-email",
        {
          method: "POST",
          headers: {
            "X-API-Key": "Dinesh@@@@",
          },
          body: emailFormData,
        }
      );

      const emailResult = await emailResponse.json();

      if (!emailResult.success) {
        console.error("Email sending failed:", emailResult.error);
        // You might want to handle this differently than throwing an error
      }

      // Show success message
      setSnackbar({
        open: true,
        message: "Application submitted successfully!",
        severity: "success",
      });

      // Reset form after successful submission
      setFormData({
        name: "",
        "email-address": "",
        "phone-number": "",
        "loan-type": "",
        state: "",
        "pin-code": "",
        "form-name": "PopUp Loan Form",
      });
    } catch (error) {
      console.error("Submission error:", error);
      setSnackbar({
        open: true,
        message: "Failed to submit application. Please try again.",
        severity: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      {/* Background content to show the popup appears after 5 seconds */}

      <StyledDialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="loan-application-form"
      >
        <CloseButton onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </CloseButton>

        <DialogContent
          sx={{
            p: isMobile ? 1 : 3,
            "&.MuiDialogContent-root": {
              paddingTop: isMobile ? "30px" : "inherit",
            },
          }}
        >
          <Box component="form" onSubmit={handleSubmit}>
            <Stack spacing={2} sx={{ mb: { xs: 1, md: 2 } }}>
              <StyledTextField
                required
                fullWidth
                size={isMobile ? "small" : "medium"}
                id="name"
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                variant="outlined"
              />

              <StyledTextField
                size={isMobile ? "small" : "medium"}
                required
                fullWidth
                id="email-address"
                label="Email"
                name="email-address"
                type="email"
                value={formData["email-address"]}
                onChange={handleChange}
                variant="outlined"
              />
            </Stack>

            <Stack
              spacing={2}
              alignItems="center"
              sx={{ mb: { xs: 1, md: 2 } }}
            >
              <StyledTextField
                required
                fullWidth
                size={isMobile ? "small" : "medium"}
                id="phone-number"
                label="Mobile No"
                name="phone-number"
                type="tel"
                value={formData["phone-number"]}
                onChange={handleChange}
                variant="outlined"
                inputProps={{ pattern: "[0-9]{10}" }}
              />

              <FormControl
                fullWidth
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    backgroundColor: "white",
                    "& fieldset": {
                      borderColor: "#e0e0e0",
                    },
                    "&:hover fieldset": {
                      borderColor: "#00cc87",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#00cc87",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#666",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#00cc87",
                  },
                }}
              >
                <InputLabel id="loan-type-label">Loan Type *</InputLabel>
                <Select
                  required
                  size={isMobile ? "small" : "medium"}
                  labelId="loan-type-label"
                  id="loan-type"
                  name="loan-type"
                  value={formData["loan-type"]}
                  onChange={handleChange}
                  label="Loan Type *"
                  sx={{
                    borderRadius: "12px",
                    fontSize: isMobile ? "14px" : "16px",
                  }}
                >
                  {loanTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>

            <Stack
              spacing={2}
              direction={{ xs: "column", md: "row" }}
              alignItems="center"
              sx={{ mb: { xs: 0, md: 2 } }}
            >
              <StyledTextField
                required
                fullWidth
                size={isMobile ? "small" : "medium"}
                id="state"
                label="State"
                name="state"
                value={formData.state}
                onChange={handleChange}
                variant="outlined"
              />

              <StyledTextField
                required
                fullWidth
                size={isMobile ? "small" : "medium"}
                id="pin-code"
                label="Pin code"
                name="pin-code"
                value={formData["pin-code"]}
                onChange={handleChange}
                variant="outlined"
                inputProps={{ pattern: "[0-9]{6}" }}
              />
            </Stack>

            <Box sx={{ mt: 2, mb: 1 }}>
              <FormControlLabel
                control={<Checkbox required color="default" />}
                sx={{ '& .MuiFormControlLabel-asterisk': { display: 'none' } }}
                label={
                  <Typography component="span" variant="body1" sx={{ display: 'inline', fontSize: { xs: "12px", md: "14px" }, textAlign: "left" }}>
                    By continuing, you agree to provide your authorization to PSN Finance, PSN Group, and its affiliated entities to store and process your data as per the{" "}
                    <Link component={RouterLink} to="/privacy-policy" underline="hover" color="primary">
                      Privacy Policy*
                    </Link>
                    .
                  </Typography>
                }
              />
            </Box>

            <Grid item xs={12}>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                <StyledButton
                  type="submit"
                  variant="contained"
                  id="apply-btn-register"
                  size="small"
                  disabled={isSubmitting}
                  sx={{
                    width: { xs: "50%", md: "150px" },
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  {isSubmitting ? "Submitting..." : "Apply"}
                </StyledButton>
              </Box>
            </Grid>
          </Box>
        </DialogContent>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </StyledDialog>
    </>
  );
}
